/**
 * @module app.core
 */

import * as Core from 'app/core/models/essette-api';

abstract class NotesEvent { }
export class NotesReloadEvent extends NotesEvent { }

abstract class NoteCategoryEvent { }
export class NoteCategoryReloadEvent extends NoteCategoryEvent { }

abstract class NotificationReloadEvent { }
export class NotificationPreferenceReloadEvent extends NotificationReloadEvent { }

abstract class LetterCopyEvent { }
export class LetterCopyForwardedEvent extends LetterCopyEvent { }

abstract class DocumentEvent { }
export class DocumentFileUploadedEvent extends DocumentEvent { }

abstract class UserTrackerEvent { }
export class UserTrackerContinueEvent extends UserTrackerEvent { }

abstract class DocumentCategoryEvent {
    public category?: Core.DocumentCategory | null;
}

export class DocumentCategorySelectedEvent extends DocumentCategoryEvent {
    constructor($category?: Core.DocumentCategory | null) {
        super();
        this.category = $category;
        return Object.assign<DocumentCategoryEvent, DocumentCategoryEvent>(this, { category: $category });
    }
}

abstract class AssessmentAttachmentCompletedEvent { }
export class AssessmentAttachmentCompletedReloadEvent extends AssessmentAttachmentCompletedEvent { }

abstract class LastEligibilityProductDeletedEvent { }
export class LastEligibilityProductDeletedReloadEvent extends LastEligibilityProductDeletedEvent { }

abstract class UserEvent { }
export class UserReloadEvent extends UserEvent { }
